import React, { useRef } from 'react';
import cn from 'classnames';
import styles from './ToggleSwitch.module.css';
import { ToggleSwitchProps } from './ToggleSwitch.interface';
import TooltipButton from '../TooltipButton';
import { useScreenWidth } from '../../hooks/useScreenWidth';

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  options,
  selectedOption,
  onChange,
  className,
  containerClassName,
  width = '130px',
  height = '35px',
  disabled = false,
  tooltipContent
}) => {
  const { isMobile } = useScreenWidth();
  const containerRef = useRef<HTMLDivElement>(null);

  const switchStyle = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  const safeOptions = Array.isArray(options) ? options : [];

  const handleOptionClick = (option: string) => {
    if (!disabled) {
      onChange(option);
    }
  };

  return (
    <div
      className={cn(styles['toggle-switch__container'], containerClassName)}
      ref={containerRef}
    >
      <div
        className={cn(styles['toggle-switch'], className, {
          [styles['toggle-switch_disabled']]: disabled
        })}
        style={switchStyle}
      >
        {safeOptions.map((option) => (
          <div
            key={option}
            onClick={() => handleOptionClick(option)}
            className={cn(styles['toggle-switch__option'], {
              [styles['toggle-switch__option_active']]: selectedOption === option,
              [styles['toggle-switch__option_disabled']]: disabled
            })}
          >
            {option.toUpperCase()}
          </div>
        ))}
      </div>

      {!isMobile && disabled && tooltipContent && (
        <div className={styles['toggle-switch__tooltip-wrapper']}>
          <TooltipButton text={tooltipContent} enableHtml={true} position="top-right"/>
        </div>
      )}
    </div>
  );
};

export default ToggleSwitch;